import { forwardRef } from 'react';
import { cx } from './cx';

export type SelectProps = React.ComponentPropsWithoutRef<'select'>;

const field =
  'ui-select appearance-none pl-4 pr-10 py-3 rounded-lg border border-neutral-300 dark:border-border-dark bg-white dark:bg-bg-dark-tertiary text-meradio-dark dark:text-text-dark-primary placeholder:text-neutral-400 dark:placeholder:text-text-dark-tertiary focus:outline-none focus:ring-2 focus:ring-meradio-primary focus:border-transparent transition-all duration-200 cursor-pointer';

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...props }, ref) => (
    <select ref={ref} className={cx(field, className)} {...props}>
      {children}
    </select>
  )
);

Select.displayName = 'Select';

export default Select;
